import script from "./ipadphoneZytz.vue?vue&type=script&setup=true&lang=js"
export * from "./ipadphoneZytz.vue?vue&type=script&setup=true&lang=js"

import "./ipadphoneZytz.vue?vue&type=style&index=0&id=2b053716&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b053716"]])

export default __exports__